import React, { Component } from 'react'

class CombinedGrid extends Component {
    constructor(props) {
        super(props)

        const { store } = props

        store.onSave = this.save
    }

    save = () => ({
        id: 'combined-grid',
    })

    render() {
        return (
            <div>Template for combined grid</div>
        )
    }
}

export default CombinedGrid
